import { useEffect, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import UserContext from 'context/UserSessionContext';
import useApi, { UPDATE_WIDGET_MAIN_SETTINGS } from 'hooks/useApi';
import { UPDATE_WIDGET } from 'hooks/useFetchCannedDashboard/actions';
import * as DASHBOARD_ACTIONS from 'hooks/useFetchCannedDashboardList/actions';

import {
  inheritDashboardProperties,
  mapWidgetType,
  updateNavigationDashboardsItem
} from 'utils/widget-helpers';

export default ({ widget, updateWidget, dashboardData, dispatchCannedDashboardList }) => {
  const history = useHistory();
  const { id } = useParams();

  const { session } = useContext(UserContext);
  const { portfolios, holdings } = session;

  const [state, makeRequest] = useApi();
  const { data, isLoading, isError } = state;

  const widgetType = widget && widget.overlay.baseWidget.widgetType.name;

  useEffect(() => {
    if (!data || isLoading || isError) {
      return;
    }

    const { id: widgetId, dashboardId, description } = data;
    const { masterObjectId: dashboardMasterObjectId } = dashboardData;
    const {
      title,
      masterObjectId,
      masterObjectTypeId,
      masterObjectName,
      benchmarks,
      timeSeriesSetId
    } = inheritDashboardProperties(data, dashboardData);

    if (dashboardData.isCanned) {
      dispatchCannedDashboardList({
        type: DASHBOARD_ACTIONS.DASHBOARD_UPDATE_LIST_ITEM,
        payload: { currentDashboardId: id, deepCopyDashboardId: dashboardId }
      });

      // This function changes the value of user context property directly without dispatching an action! Keep in mind!
      updateNavigationDashboardsItem({ portfolios, holdings, masterObjectId, id, dashboardId });

      history.push(`/canned/${dashboardMasterObjectId}/${dashboardId}`);
    } else {
      const widgetMainSettingsUpdateProps = {
        title,
        masterObjectId,
        masterObjectName,
        masterObjectTypeId,
        benchmarks,
        description,
        timeSeriesSetId
      };

      updateWidget({
        type: UPDATE_WIDGET,
        payload: {
          id: widgetId,
          data: widgetMainSettingsUpdateProps
        }
      });
    }
  }, [data, isLoading, isError, updateWidget, dashboardData, history, dispatchCannedDashboardList]); //eslint-disable-line

  const onMainSettingsSubmit = formData => {
    const benchmarks =
      widget.benchmarks && widget.benchmarks.length > 0
        ? widget.benchmarks
        : dashboardData.benchmarks;

    const {
      isCanned,
      masterObjectId: dashboardMasterObjectId,
      masterObjectTypeId: dashboardMasterObjectTypeId,
      objectTypeDetailId: dashboardObjectTypeDetailId
    } = dashboardData;

    const mainSettingsData = {
      title: widget.title,
      masterObjectTypeId: widget.masterObjectTypeId,
      masterObjectId: widget.masterObjectId,
      benchmarks: benchmarks.map(b => b.benchmarkId)
    };

    const updateData = {
      id: widget.id,
      widgetType: mapWidgetType(widgetType),
      ...mainSettingsData,
      ...formData
    };

    if (isCanned) {
      updateData.dashboardMasterObjectId = dashboardMasterObjectId;
      updateData.dashboardMasterObjectTypeId = dashboardMasterObjectTypeId;
      updateData.dashboardObjectTypeDetailId = dashboardObjectTypeDetailId;
    }

    makeRequest(UPDATE_WIDGET_MAIN_SETTINGS({ ...updateData }));
  };

  return [onMainSettingsSubmit];
};
